import { ICreateRestaurantContext } from './createRestaurantContext';

export enum CreateRestaurantActionTypes {
	SET_FETCHED_COUNTRIES = 'SET_FETCHED_COUNTRIES',
	SET_ID_COUNTRY = 'SET_ID_COUNTRY',
	SET_FETCHED_CITIES = 'SET_FETCHED_CITIES',
	SET_ID_CITY = 'SET_ID_CITY',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_CLIENT_TYPE = 'SET_CLIENT_TYPE',
	CHANGE_NAME = 'CHANGE_NAME',
	SET_FETCHED_CURRENCIES = 'SET_FETCHED_CURRENCIES',
	SET_CURRENCY_SYMBOL = 'SET_CURRENCY_SYMBOL',
	CHANGE_ADDRESS = 'CHANGE_ADDRESS',
	CHANGE_EMAIL = 'CHANGE_EMAIL',
	CHANGE_CODE = 'CHANGE_CODE',
	CHANGE_PRICE_TYPE = 'CHANGE_PRICE_TYPE',
	TOGGLE_IS_USED_CUSTOMER_PRICE_TYPE = 'TOGGLE_IS_USED_CUSTOMER_PRICE_TYPE',
	SET_ID_POS_SYSTEM = 'SET_ID_POS_SYSTEM',
	SET_FETCHED_LANGUAGES = 'SET_FETCHED_LANGUAGES',
	SET_ID_DEFAULT_LANGUAGE = 'SET_ID_DEFAULT_LANGUAGE',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface ISetFetchedCountries {
	type: CreateRestaurantActionTypes.SET_FETCHED_COUNTRIES;
	payload: {
		fetchedCountries: ICreateRestaurantContext['fetchedCountries'];
	};
}

interface ISetIDCountry {
	type: CreateRestaurantActionTypes.SET_ID_COUNTRY;
	payload: {
		IDSelectedCountry: ICreateRestaurantContext['IDSelectedCountry'];
	};
}

interface ISetFetchedCities {
	type: CreateRestaurantActionTypes.SET_FETCHED_CITIES;
	payload: {
		fetchedCities: ICreateRestaurantContext['fetchedCities'];
	};
}

interface ISetIDCity {
	type: CreateRestaurantActionTypes.SET_ID_CITY;
	payload: {
		IDSelectedCity: ICreateRestaurantContext['IDSelectedCity'];
	};
}

interface ISetFetchedCustomers {
	type: CreateRestaurantActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		fetchedCustomers: ICreateRestaurantContext['fetchedCustomers'];
	};
}

interface ISetIDCustomer {
	type: CreateRestaurantActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: ICreateRestaurantContext['IDSelectedCustomer'];
		isUsedCustomerPriceType: ICreateRestaurantContext['isUsedCustomerPriceType'];
	};
}

interface ISetClientType {
	type: CreateRestaurantActionTypes.SET_CLIENT_TYPE;
	payload: {
		clientType: ICreateRestaurantContext['clientType'];
	};
}

interface IChangeName {
	type: CreateRestaurantActionTypes.CHANGE_NAME;
	payload: {
		name: ICreateRestaurantContext['name'];
	};
}

interface ISetFetchedCurrencies {
	type: CreateRestaurantActionTypes.SET_FETCHED_CURRENCIES;
	payload: {
		fetchedCurrencies: ICreateRestaurantContext['fetchedCurrencies'];
	};
}

interface ISetCurrencySymbol {
	type: CreateRestaurantActionTypes.SET_CURRENCY_SYMBOL;
	payload: {
		selectedCurrencySymbol: ICreateRestaurantContext['selectedCurrencySymbol'];
	};
}

interface IChangeAddress {
	type: CreateRestaurantActionTypes.CHANGE_ADDRESS;
	payload: {
		address: ICreateRestaurantContext['address'];
	};
}

interface IChangeEmail {
	type: CreateRestaurantActionTypes.CHANGE_EMAIL;
	payload: {
		email: ICreateRestaurantContext['email'];
	};
}

interface IChangeCode {
	type: CreateRestaurantActionTypes.CHANGE_CODE;
	payload: {
		code: ICreateRestaurantContext['code'];
	};
}

interface IChangePriceType {
	type: CreateRestaurantActionTypes.CHANGE_PRICE_TYPE;
	payload: {
		priceType: ICreateRestaurantContext['priceType'];
	};
}

interface IToggleIsUsedCustomerPriceType {
	type: CreateRestaurantActionTypes.TOGGLE_IS_USED_CUSTOMER_PRICE_TYPE;
	payload: {
		isUsedCustomerPriceType: ICreateRestaurantContext['isUsedCustomerPriceType'];
		priceType: ICreateRestaurantContext['priceType'];
	};
}

interface ISetIDPosSystem {
	type: CreateRestaurantActionTypes.SET_ID_POS_SYSTEM;
	payload: {
		IDPosSystem: ICreateRestaurantContext['IDPosSystem'];
	};
}

interface ISetFetchedLanguages {
	type: CreateRestaurantActionTypes.SET_FETCHED_LANGUAGES;
	payload: {
		fetchedLanguages: ICreateRestaurantContext['fetchedLanguages'];
	};
}

interface ISetIDDefaultLanguage {
	type: CreateRestaurantActionTypes.SET_ID_DEFAULT_LANGUAGE;
	payload: {
		IDSelectedDefaultLanguage: ICreateRestaurantContext['IDSelectedDefaultLanguage'];
	};
}

interface ISetDataForSubmit {
	type: CreateRestaurantActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateRestaurantContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateRestaurantActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: ICreateRestaurantContext['typeOfModalWindow'];
	};
}

interface IResetSelectedControls {
	type: CreateRestaurantActionTypes.RESET_FIELDS;
}

export type TCreateRestaurantAction =
	| ISetFetchedCountries
	| ISetIDCountry
	| ISetFetchedCities
	| ISetIDCity
	| ISetFetchedCustomers
	| ISetIDCustomer
	| ISetClientType
	| IChangeName
	| ISetFetchedCurrencies
	| ISetCurrencySymbol
	| IChangeAddress
	| IChangeEmail
	| IChangeCode
	| IChangePriceType
	| IToggleIsUsedCustomerPriceType
	| ISetIDPosSystem
	| ISetFetchedLanguages
	| ISetIDDefaultLanguage
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IResetSelectedControls;
